// What Plan shows outside the story's scenes (the app's `LibraryModel.planShowsScenes`, PhonePlanPage.swift, and
// OutlinerView's `sceneFields`): Research & Notes, the Publishing folders and the Trash aren't scenes, so their corkboard
// counts "documents", has no swimlanes, heatmap or cold marks, and the outliner leaves out the scene columns.
import type { ArrangementRole, FieldType } from '../contract.ts';
import { StandardField } from '../project.ts';

/** `planShowsScenes`: whether Plan is showing the story's scenes — the manuscript, an alternate order of it, or a
 *  collection — rather than research, notes or book matter (no arrangement: yes). */
export function planShowsScenes(role: ArrangementRole | null | undefined): boolean {
  if (!role) return true;
  return role === 'manuscript' || role === 'alternate' || role === 'collection';
}

/** `OutlinerView.sceneFields`: fields that describe a scene (or a journal's post), left out of the outliner for other
 *  documents — with the point of view, which has a column of its own there. */
export const SCENE_FIELDS: ReadonlySet<string> = new Set([
  StandardField.sectionType, StandardField.setting, StandardField.storyDuration, StandardField.beat, StandardField.postNumber,
  StandardField.publishDate, StandardField.tags,
]);

/** The fields the outliner gives columns to: all of them for scenes; for other documents, none of the scene fields, the
 *  point of view or story times. */
export function outlinerFields<F extends { id: string; type: FieldType }>(fields: readonly F[], scenes: boolean): F[] {
  return scenes ? [...fields] : fields.filter((f) => f.id !== StandardField.pov && f.type !== 'story-time' && !SCENE_FIELDS.has(f.id));
}
